<template lang="pug">
AppPopover(
  ref="AppPopover"
  trigger="hover"
  placement="right"
  extra-popover-classes="vue-time-entries-copy-preview-popover"
  popover-container-classes="d-inline-block"
  :disabled="disabled"
  :lazy="lazy"
)
  template(#body)
    span
      p
      | {{ popoverText }}
    p(
      v-for="(name, index) in projectNames"
      :key="`${name}-${index}`"
    )
      AppAvatarInitial(
        :text="name"
        size="speck"
      )
      span
        | {{ name }}
    p(v-if="moreMessage")
      | {{ moreMessage }}
  template(#trigger)
    slot(name="trigger")
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'TimeEntriesCopyPreviewPopover',
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    lazy: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    ...mapGetters(['getProject', 'filteredProjectTasks', 'projectFlavour']),
    projectNames() {
      const projectIds = this.projectIds.slice(0, 8);

      return projectIds.map((projectId) => this.getProject(projectId).text);
    },
    moreMessage() {
      const difference = this.projectIds.length - this.projectNames.length;

      return difference > 0 ? `+${difference} more` : null;
    },
    projectIds() {
      const projectIds = this.filteredProjectTasks.map((pt) => pt[0]);

      return Array.from(new Set(projectIds));
    },
    popoverText() {
      if (this.projectFlavour === 'both') {
        return 'Copy these projects / work orders from the most recent timesheet:';
      }
      if (this.projectFlavour === 'work_orders') {
        return 'Copy these work orders from the most recent timesheet:';
      }

      return 'Copy these projects from the most recent timesheet:';
    },
  },
};
</script>
